import React, {Component} from "react"
import PropTypes from "prop-types"
import MaskedInput from 'react-text-mask'

export default class NRTTextInput extends Component {

    inputRef = React.createRef()
    Cmp = () => null

    state = {
        value: ''
    }

    updatingfromSetState = false


    componentWillMount() {
        this.Cmp = (!!this.props.mask) ? MaskedInput : (props) => <input {...props}/>
    }


    componentDidUpdate(prevProps, prevState) {


        if (this.updatingfromSetState) {
            this.updatingfromSetState = false
            return
        }



        if (this.props.value !== this.state.value)
            this.setState({value: this.props.value})

    }


    focus() {
        this.inputRef.current.focus()
    }


    handleChange = (evt) => {
        let value = evt.target.value


        if (value.length > this.props.maxlength)
            return


        this.updatingfromSetState = true
        this.setState({
                value,
            },
            () => {
                this.props.changeValueAction(this.state.value)
            }
        )

    }

    checkIfIsEnterKey = (evt) => {
        if (evt.key === 'Enter')
            return this.props.onEnterPressed()
    }


    render() {

        const Cmp = this.Cmp


        return (
            <Cmp
                onBlur={this.props.onBlur}
                onFocus={this.props.onFocus}
                onKeyDown={this.checkIfIsEnterKey}
                ref={this.inputRef}
                type={"text"}
                {...this.props}
                value={this.state.value || ''}
                onChange={this.handleChange}

            />
        )
    }
}

NRTTextInput.propTypes = {
    onEnterPressed: PropTypes.func,
    value: PropTypes.string,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    changeValueAction: PropTypes.func.isRequired,
    maxlength: PropTypes.number,
    mask: PropTypes.array,

}

NRTTextInput.defaultProps = {
    onEnterPressed: () => null,
    onChange: () => null,
    onFocus: () => null,
    onBlur: () => null,

}



// WEBPACK FOOTER //
// ./src/components/_common/_controlled-inputs/TextInput/index.js